<template>
  <div>
    <v-card
      class="mx-3 my-2 px-2 py-2 mt-3 font-weight-bold"
      style="background: red; color: white"
      v-if="role !== 'USER'"
    >
      Vous êtes membre de l'équipe Home In Love, les modifications ne peuvent
      être faite que depuis le partner. Les changements ici ne seront pas pris
      en compte.
    </v-card>
    <v-card
      class="mx-3 my-2 px-2 py-2 mt-3 font-weight-bold"
      style="background: red; color: white"
    >
      La première étape de votre accompagnement c'est de bien décrire votre
      projet, merci de relire et compléter les informations via les champs
      CI-DESSOUS.
    </v-card>
    <v-container fluid v-if="!loading && (isNewProject || project != null)">
      <v-layout row wrap class="align-baseline">
        <v-flex xs12 lg4>
          <v-card class="mx-3 my-3 px-2 py-3">
            <h2>Mon projet</h2>
            <ProjectBasics v-model="basics" :project="project" />
          </v-card>
          <v-card class="mx-3 my-3 px-2 py-3">
            <h2>Entreprise</h2>
            <ProjectCompany v-model="company" :project="project" />
          </v-card>
          <v-card class="mx-3 my-3 px-2 py-3">
            <h2>Prescripteur</h2>
            <ProjectPrescriber v-model="prescriber" :project="project" />
          </v-card>
        </v-flex>
        <v-flex xs12 lg8>
          <v-card class="mx-3 my-3 px-2 py-3">
            <h2>Votre situation</h2>
            <ProjectSituation
              :is-new="isNewProject"
              v-model="situation"
              :project="project"
            />
          </v-card>
          <v-card class="mx-3 my-3 px-2 py-3">
            <h2>Bien recherché</h2>
            <ProjectHost
              :is-new="isNewProject"
              v-model="host"
              :project="project"
              :location="location"
            />
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="align-baseline">
        <v-flex xs12 class="d-flex" v-if="role === 'USER'">
          <v-btn
            v-if="!loading"
            @click="saveProject"
            :disabled="saveLoading"
            color="primary"
            class="hidden-print-only"
          >
            <v-icon class="mr-2">save</v-icon>
            Enregistrer mon projet</v-btn
          >
          <v-progress-circular v-else />
        </v-flex>
      </v-layout>
    </v-container>
    <div v-else>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-snackbar v-model="showMessage">
      {{ message }}
    </v-snackbar>
  </div>
</template>
<script>
import ProjectBasics from "../components/project/ProjectBasics";
import ProjectCompany from "../components/project/ProjectCompany";
import ProjectPrescriber from "../components/project/ProjectPrescriber";
import ProjectHost from "../components/project/ProjectHost";
import ProjectSituation from "../components/project/ProjectSituation";
import { fetchHil } from "../utils";

export default {
  data() {
    return {
      loading: true,
      saveLoading: false,
      basics: null,
      company: null,
      prescriber: null,
      host: null,
      situation: null,
      showMessage: false,
      message: ""
    };
  },
  components: {
    ProjectPrescriber,
    ProjectCompany,
    ProjectBasics,
    ProjectHost,
    ProjectSituation
  },
  computed: {
    isValid() {
      return (
        this.basics != null &&
        this.company != null &&
        this.prescriber != null &&
        this.host != null &&
        this.situation != null
      );
    },
    isNewProject() {
      return this.$route.params.lease_id == null;
    },
    project() {
      return this.$store.state.currentProject;
    },
    location() {
      return undefined;
    },
    role() {
      return this.$store.state.user.role;
    }
  },
  async mounted() {
    let id = this.$route.params.lease_id;
    if (id != null) {
      await this.$store.dispatch("fetchProject", { id });
    } else if (this.$store.state.user.projectId != null) {
      this.$router.push("/");
    }
    this.loading = false;
  },
  methods: {
    async saveProject() {
      if (!this.isValid) {
        this.message = "La saisie n'est pas valide";
        this.showMessage = true;
        return;
      }

      const {
        actualCity,
        actualCityObject,
        dateMove,
        firstName,
        lastName,
        phone,
        sponsor,
        serviceWish,
        moveWish
      } = this.basics;
      const {
        contractType,
        company,
        companyContactName,
        companyPhone,
        companyMail,
        addressWork,
        addressWorkObject
      } = this.company;
      const { school, schoolMail, schoolPhone } = this.prescriber;
      const {
        favoritePlaces,
        typeOfEstate,
        surfacemin,
        budget,
        numberOfRoom,
        descEstate,
        futurNeighborhood,
        criterion1,
        criterion2,
        criterion3
      } = this.host;
      const { aboutYou } = this.situation;
      const lease = {
        actualCity,
        companyContactName,
        companyMail,
        companyPhone,
        firstName,
        lastName,
        contractType,
        phoneNumber: phone,
        dateMove,
        addressWork,
        addressWorkObject,
        fromAddressObject: actualCityObject,
        company,
        school,
        schoolMail,
        schoolPhone,
        favoritePlaces,
        typeOfEstate,
        surfacemin,
        budget,
        numberOfRoom,
        descEstate,
        futurNeighborhood,
        aboutYou,
        criterion1,
        criterion2,
        criterion3,
        sponsor,
        serviceWish,
        moveWish
      };

      const requireds = [firstName, lastName, phone];

      if (requireds.filter(r => r == null || r === "").length > 0) {
        this.showMessage = true;
        this.message = "Tous les champs obligatoires n'ont pas été saisis";
        return;
      }

      let _id;
      this.saveLoading = true;

      _id = this.project._id;

      const resp = await fetchHil(`/lease/${_id}`, {
        method: "PUT",
        body: lease
      });

      if (!resp.ok) {
        this.saveLoading = false;
        console.error("could not update");
        this.message = "Une erreur a eu lieu";
        this.showMessage = true;
        return;
      }

      this.saveLoading = false;
      this.message = "Modifications enregistrées";
      this.showMessage = true;
    }
  }
};
</script>
<style></style>
